import { useNavigate } from "react-router-dom";
import "./styles.css";

function Obrigado() {
  const navigate = useNavigate();

  const handleRedirectToStatus = async () => {
    navigate("/");
  };

  return (
    <div className="containerWrapper">
      <div className="thanksMessage">
        <div className="logo">
          <img src="https://i.imgur.com/bMhAXFy.png" alt="Logo link do bem" />
        </div>

        <div className="message">
          <h1>Obrigado!</h1>

          <div className="messageInfo">
            <p>
              Tudo certo, agora acesse sua conta para acompanhar o status do seu
              pedido!
            </p>
          </div>

          <button className="accessButton" onClick={handleRedirectToStatus}>
            Acessar conta
          </button>
        </div>
      </div>
    </div>
  );
}

export default Obrigado;
